import Link from "next/link";
import React from "react";
import cx from "classnames";
import { routesURL } from "../urls";
const NavLink = ({ link, text }) => (
  <li>
    <Link
      href={link}
      className=" hover:text-[#FDFDFD] h-full w-full font-inter"
      aria-label={`flamingos-navigation-link-${text}`}
    >
      {text}
    </Link>
  </li>
);
const Nav = () => {
  const links = [
    {
      text: "About",
      link: routesURL.about,
    },
    {
      text: "Features",
      link: "/#features",
    },
    {
      text: "Pricing",
      link: routesURL.pricing,
    },
    {
      text: "Blog",
      link: routesURL.blog,
    },
    {
      text: "FAQ",
      link: "/#FAQ",
    },
  ];
  return (
    <nav className=" mx-auto w-[850px] flex items-center justify-between px-[20px] py-[8px] bg-[#0F0F0F] border-[#292929] border rounded-[15px] ">
      <Link href={routesURL.index}>
        <div className=" text-[24px] text-[#fdfdfd] font-medium">flamingos</div>
      </Link>
      <ul className=" flex items-center justify-between text-[#A9A9A9] gap-x-[40px] text-[13px]">
        {links.map((item, index) => (
          <NavLink key={index} text={item.text} link={item.link} />
        ))}
      </ul>
      <div className=" flex items-center justify-center gap-x-4">
        <Link href={routesURL.login} target="__blank">
          <button className=" bg-[#f9f9f9] w-[68px] h-[32px] flex items-center justify-center font-inter rounded-[10px] font-semibold text-[12px] hover:scale-105 duration-200">
            Log in
          </button>
        </Link>
        <Link href={routesURL.signup} target="__blank">
          <button className="bg-[rgba(123,123,123,.2)] w-[78px] h-[32px] flex items-center justify-center font-inter rounded-[10px] font-semibold text-[12px] text-[#FFFFFF] hover:scale-105 duration-200">
            Sign up
          </button>
        </Link>
      </div>
    </nav>
  );
};
const Pattern = () => (
  <div className=" absolute w-full h-[100%] left-1/3 top-[50px] square-pattern bg-black-6" />
);
const Hero = () => {
  return (
    <div className=" h-[calc(100vh-50px-30px)] relative overflow-x-hidden overflow-y-hidden">
      <Pattern />
      <div className=" flex items-center justify-center h-full relative z-50 px-32 gap-x-[60px]">
        <div className=" basis-[40%] relative">
          <h1 className="text-[40px] font-medium text-[#EDEDED]">
            One tool for all your
            <br />
            Data analysis
          </h1>
          <p className=" text-[#A9A9A9] mt-7 font-inter text-[14px]">
            Flamingos is a data analytics platform that enables you to analyse
            your data in an easy to use, blazing fast and AI powered way.
          </p>
          <p className=" text-[#EDEDED] mt-7 font-inter text-[13px] font-semibold">
            No infra setup, No complex data pipelines, No expensive cloud bills
          </p>
          <Link href={routesURL.login} target="__blank">
            <button className=" bg-white px-[20px] py-[8px] rounded-[10px] font-inter font-semibold text-[13px] antialiased mt-[40px] block hover:scale-105 transition-transform duration-200">
              30-Day FREE Trial
            </button>
          </Link>
        </div>
        <div className=" basis-[70%]">
          <video
            src="/videos/notebook-demo-1-fast.mp4"
            className=" w-full h-full rounded-[5px]"
            title="flamingos-hero-video-1"
            autoPlay
            loop
            muted
            playsInline
          />
        </div>
      </div>
    </div>
  );
};
const Header = ({ children, showHero = true }) => {
  return (
    <React.Fragment>
      <header
        className={cx(" bg-black-6 pt-[30px] font-geoGraph", {
          "h-screen ": showHero,
        })}
      >
        <Nav />
        {showHero && <Hero />}
      </header>
      {children}
    </React.Fragment>
  );
};

export default Header;
